export function required(value){
  return (((value) && (value !== '') && (value !== ' ')) ? undefined : "Campo obrigatório");
}